import React, {useEffect, useState} from 'react';
import {toast} from "react-toastify";
import AdminCashierAPI from "../../../apis/adminApi/AdminCashierAPI";
import Field from "../../forms/Field";
import Select from "../../forms/Select";
import MyButton from "../../assets/MyButton";


const AdminCashIn = () => {

    const [showLoader, setShowLoader] = useState(false);
    const [loading, setLoading] = useState(true);
    const [setting, setSetting] = useState([]);
    const [boxUSB, setBoxUSB] = useState([]);
    const [boxCDF, setBoxCDF] = useState([]);
    const [sources, setSources] = useState([]);
    const [cashAccounts, setCashAccounts] = useState([]);


    const [cashIn, setCashIn] = useState({
        source : "",
        currency : "",
        amount : "" ,
        created_at : "",
        description : ""
    });

    const [errors, setErrors] = useState({
        source : "",currency : "", amount : "", created_at : ""
    });


    const getCashSources = async () => {
        try{
            const data =  await AdminCashierAPI.findCashAccounts();
            setSources(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes sources !");
        }
    };

    const getUSDCashBox = async () => {
        try{
            const data =  await AdminCashierAPI.getUSBCashBox();
            setBoxUSB(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement de la casse USD !");
        }
    };

    const getCDFCashBox = async () => {
        try{
            const data =  await AdminCashierAPI.getCDFCashBox();
            setBoxCDF(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement de la casse FC !");
        }
    };

    const fetchCashAccounts = async () => {
        try{
            const data =  await AdminCashierAPI.findCashAccounts();
            setCashAccounts(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes sources !");
        }
    };

    useEffect(() => {
        getUSDCashBox();
        getCDFCashBox();
        getCashSources();
        fetchCashAccounts();
        return () => console.log("");
    },[]);



    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setCashIn({...cashIn, [name] : value, description : "L'approvisionnement de " + cashIn.amount + " " + cashIn.currency + " s'est effectué  avec succès"});
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        try{
            setShowLoader(true);
            await AdminCashierAPI.storeCashIn(cashIn);
            setTimeout(() => setShowLoader(false), 100);
            toast.success("Appro ajouté avec succès");
            window.location.reload();
        }catch({response}){
            const {violations} = response.data;
            setTimeout(() => setShowLoader(false), 100);

            if(violations){
                const apiErrors = {};
                Object.keys(violations).forEach(key => {
                    apiErrors[key] = violations[key]
                });
                setErrors(apiErrors);
                toast.error("Une erreur est servenue dans le formulaire d'ajout de l'appro !");
            }

            const {message} = response.data;
            const {attribute} = response.data;
            if(attribute === "amount"){
                setErrors({"amount" : message});
                toast.error(message);
            }
            if(attribute === "source"){
                setErrors({"source" : message});
                toast.error(message);
            }
        }
    };



    return <div className="container">
        <div className="row justify-content-center">
            <div className="col-md-4">

                <div className="card">
                    <form onSubmit={handleSubmit} className="needs-validation">
                        <div className="card-body">
                            <h3 className="text-success fw-bold p-2">Approvisionnement</h3>
                            <hr/>

                            <Field
                                name="amount"
                                type="number"
                                error={errors.amount}
                                value={cashIn.amount}
                                onChange={handleChange}
                                label="Montant"
                                placeholder="000"
                            />

                            <Select name="currency" label="Devise"
                                    value={cashIn.currency} error={errors.currency}
                                    onChange={handleChange}>
                                <option value="">Choisir...</option>
                                <option value="FC">CDF</option>
                                <option value="USD">USD</option>
                            </Select>
                            {errors.currency && <div className="invalid-feedback mb-4">{errors.currency}</div>}

                            <label htmlFor="source" className="form-label">Source</label>
                            {!loading &&
                                <select
                                    className={"form-select-sm form-control mb-2 " + ( errors.source && "is-invalid")}
                                    //size={(buses.length)}
                                    name="source"
                                    id="source"
                                    value={cashIn.source}
                                    onChange={handleChange}
                                >

                                    <option value="">Choisir...</option>
                                    {sources && sources.map((source) => (
                                        <option key={source.id} value={source.name}>
                                            {source.name}</option>
                                    ))
                                    }
                                </select>
                            }
                            {errors.account && <div className="invalid-feedback mb-4">{errors.account}</div>}

                            <Field
                                name="created_at"
                                type="date"
                                error={errors.created_at}
                                value={cashIn.created_at}
                                onChange={handleChange}
                                label="Date"
                                autoComplete="off"
                            />
                            <hr/>

                            <MyButton
                                text="Enregistrer"
                                onSubmit={handleSubmit}
                                loading={showLoader}
                                disabled={showLoader}
                            />
                        </div>
                    </form>
                </div>

            </div>
            <div className="col-md-8">
                <div className="row">
                    {cashAccounts && cashAccounts.map((cashAccount) =>
                        <div className="col-md-5">
                            <div className="card bg-success-light">
                                <div className="card-body p-3">
                                    <div className="row d-flex justify-content-center border-dashed-bottom pb-3">
                                        <div className="col-9">
                                            <p className="text-dark mb-0 fw-semibold fs-14">{cashAccount.name}</p>
                                            <h3 className="mt-2 mb-0 fw-bold">
                                                {cashAccount.t_amount} {cashAccount.currency}
                                            </h3>
                                        </div>
                                        <div className="col-3 align-self-center">
                                            <div
                                                className="d-flex justify-content-center align-items-center thumb-xl bg-light rounded-circle mx-auto">
                                                <i
                                                    className="iconoir-percentage-circle h1 align-self-center mb-0 text-secondary"></i>
                                            </div>
                                        </div>
                                    </div>
                                    {/*<p className="mb-0 text-truncate text-muted mt-3"><span className="text-danger">8%</span>*/}
                                    {/*    Up Bounce Rate Weekly</p>*/}
                                </div>
                            </div>
                        </div>)}
                </div>
            </div>
        </div>
    </div>;
};

export default AdminCashIn;
